import Lightbulb from '#assets/example-assets/light-bulb.svg';
import { loadTheme } from '../load-theme';
// eslint-disable-next-line import/extensions
import { archetypeLightStitchesTheme } from './archetype-light-theme';
// eslint-disable-next-line import/extensions
import { archetypeDarkTheme } from './archetype-dark-theme';
import { leagueTheme } from './league-b2b-theme';

const options = {
  customIcons: {
    customLightbulb: Lightbulb,
    customSVGDataURI:
      'data:image/svg+xml,%3Csvg%20id%3D%22customSVGDataURI%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%3E%0A%20%20%3Cpath%20fill%3D%22none%22%20stroke%3D%22%236a6%22%20stroke-width%3D%2210%22%20d%3D%22m-13.6%2027%2023-20.7%2026.5%2022%22%2F%3E%0A%3C%2Fsvg%3E',
  },
  customStrings: {
    loadingText: 'Custom loading text',
  },
  themeName: 'wireframe',
};

// Uses pre-formatted Stitches theme to exercise the optimized loading path.
// In JSDOM storyshot tests, Stitches $token refs (e.g. $body) appear as
// literal CSS values because JSDOM cannot resolve CSS custom properties.
// This is expected test-environment behavior, not a production regression.
export const storybookArchetypeLightTheme = loadTheme(
  archetypeLightStitchesTheme,
  {
    ...options,
    themeName: 'archetype-light',
  },
);
export const storybookArchetypeDarkTheme = loadTheme(archetypeDarkTheme, {
  ...options,
  themeName: 'archetype-dark',
});
export const storybookLeagueTheme = loadTheme(leagueTheme, {
  ...options,
  themeName: 'league',
});
